// Hero scroll-driven parallax.
// Portado de qualiapps-lading-page.html linhas 3858-3924.
// Mantém a mesma matemática: smoothstep easing aplicado ao progresso
// (0..1) do stage de 220vh, com squares voando para fora + content
// fade/scale + scroll-hint fade.

type SquareCache = {
  el: HTMLElement;
  rot: number;
  dx: number;
  dy: number;
  drot: number;
  dz: number;
};

export function initHeroParallax(): void {
  const stage = document.querySelector<HTMLElement>(".hero-stage");
  const canvas = document.getElementById("heroCanvas");
  const content = document.getElementById("heroContent");
  const hint = document.querySelector<HTMLElement>(".scroll-hint");

  if (!stage || !canvas || !content) return;

  const squares: SquareCache[] = Array.from(
    canvas.querySelectorAll<HTMLElement>(".sq"),
  ).map((el) => ({
    el,
    rot: parseFloat(el.dataset.rot ?? "0"),
    dx: parseFloat(el.dataset.dx ?? "0"),
    dy: parseFloat(el.dataset.dy ?? "0"),
    drot: parseFloat(el.dataset.drot ?? "0"),
    dz: parseFloat(el.dataset.dz ?? "0"),
  }));

  // Respect prefers-reduced-motion: place once, no listeners.
  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function place(): void {
    const W = window.innerWidth;
    const H = window.innerHeight;
    squares.forEach(({ el }) => {
      const px = parseFloat(el.dataset.x ?? "0"); // % da meia-largura do viewport
      const py = parseFloat(el.dataset.y ?? "0"); // % da meia-altura
      const size = parseFloat(el.dataset.size ?? "60");
      el.style.width = el.style.height = `${size}px`;
      const cx = W / 2 + (px / 100) * (W / 2) - size / 2;
      const cy = H / 2 + (py / 100) * (H / 2) - size / 2;
      el.style.left = `${cx}px`;
      el.style.top = `${cy}px`;
    });
  }

  let raf = 0;
  function update(): void {
    raf = 0;
    if (!stage) return;
    const rect = stage.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const scrolled = -rect.top;
    const p = total > 0 ? Math.max(0, Math.min(1, scrolled / total)) : 0;

    // smoothstep easing: aceleração suave do parallax
    const ep = p * p * (3 - 2 * p);

    for (const sq of squares) {
      const dx = sq.dx * ep;
      const dy = sq.dy * ep;
      const drot = sq.drot * ep + sq.rot;
      const dz = 1 + sq.dz * ep;
      sq.el.style.transform = `translate3d(${dx}px, ${dy}px, 0) rotate(${drot}deg) scale(${dz})`;
      sq.el.style.opacity = `${1 - ep * 0.5}`;
    }

    if (content) {
      const scale = 1 - ep * 0.12;
      const ty = ep * -30;
      content.style.transform = `scale(${scale}) translate3d(0, ${ty}px, 0)`;
      content.style.opacity = `${Math.max(0, 1 - ep * 1.8)}`;
    }
    if (hint) {
      hint.style.opacity = `${Math.max(0, 1 - p * 4)}`;
    }
  }

  function onScroll(): void {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  function onResize(): void {
    place();
    update();
  }

  place();

  if (reduced) {
    // Apenas posiciona; sem listeners de scroll/resize.
    return;
  }

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);
}
